import React from 'react';
import { IOrder } from '../../types';

export const OrderProductsDetail: React.FC<{ order: IOrder }> = ({ order }) => (
  <ul>
    {order.productsWithQuantity.map((product) => (
      <li key={product.id}>
        <span>{`${product.quantity}${product.quantityUnit || product.unit} ${product.name}`}</span>
      </li>
    ))}
  </ul>
);
